import React from 'react'

const Gallery = () => {
  return (
    <>
     <div className="container-fluid">
    <div className="first">
        
        <div className="one">
            <img src="./img1/g12.jpg" alt="" />
        </div>
        <div className="one">
            <img src="./img1/g2.jpg" alt="" />
        </div>
        <div className="one">
            <img src="./img1/g3.jpg" alt="" />
        </div><div className="one">
            <img src="./img1/g4.jpg" alt="" />
        </div>
    </div>
        <div className="first">
        
            <div className="one">
                <img src="./img1/g5.jpg" alt="" />
            </div>
            <div className="one">
                <img src="./img1/g6.jpg" alt="" />
            </div><div className="one">
                <img src="./img1/g7.jpg" alt="" />
            </div><div className="one">
                <img src="./img1/g8.jpg" alt="" />
            </div>
        </div>
        <div className="first">
            <div className="one">
                <img src="./img1/g9.jpg" alt="" />
            </div>
            <div className="one">
                <img src="./img1/g10.jpg" alt="" />
            </div><div className="one">
                <img src="./img1/g11.jpg" alt="" />
            </div><div className="one">
                <img src="./img1/g1.jpg" alt="" />
            </div>
        </div>
    </div>
      
    </>
  )
}

export default Gallery
